import axios from 'axios';
import authService from './authService';

const API_URL = '/api/onestop/';

// Add a request interceptor to include the auth token
axios.interceptors.request.use(
  (config) => {
    const user = authService.getCurrentUser();
    if (user && user.accessToken) {
      config.headers.Authorization = 'Bearer ' + user.accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

class OneStopService {
  // Public endpoints
  getTreeStructure() {
    return axios.get(API_URL + 'tree');
  }

  getNodeById(id) {
    return axios.get(API_URL + `node/${id}`);
  }

  getNodeChildren(id) {
    return axios.get(API_URL + `node/${id}/children`);
  }

  // Admin endpoints
  getAllNodes() {
    return axios.get(API_URL + 'admin/all');
  }

  createNode(nodeData) {
    return axios.post(API_URL + 'admin', nodeData);
  }

  updateNode(id, nodeData) {
    return axios.put(API_URL + `admin/${id}`, nodeData);
  }

  deleteNode(id) {
    return axios.delete(API_URL + `admin/${id}`);
  }
}

export default new OneStopService();